import {CPSConstants} from "commonUtils/enumerations";

export interface MicellaneousPros {
  miscData: {
    permissionToViewORF: boolean;
    orfUrl: string;
    arfUrl: boolean;
    permissionToViewARF: boolean;
    permissionToViewPaymentLimitsReport: boolean;
    dashboardAlerts: [
      {
        alertName: string;
        alertCount: number;
        pageToLoad: string;
      },
    ];
    announcements: [
      {
        announcementKey: number;
        subject: string;
        content: string;
        fromDate: string;
        sentBy: string;
        sentWhen: string;
        filePath: string;
      },
    ];
    isViewAllAnnouncement: false;
    messageCode?: number;
    message?: string;
    isSuccessMessage?: boolean;
    isErrorMessage?: boolean;
    isValidationMessage?: boolean;
  };
}

export const dashBoardMiscstyle = {
  miscTypoStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#193F89",
    opacity: 1,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    paddingBottom: "0.313rem",
    fontSize: CPSConstants.FONTREMHEAD,
  },
  cusrsorPointer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
  },
  listStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    overflowY: "auto",
    bgcolor: "hsl(220deg 60% 98.04%)",
  },
  miscellaneousServicesOutlinedIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0.625rem",
  },
  reportSection: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
    color: "#666666",
  },
  individualPaymentLimit: {
    fontWeight: "bold",
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    color: "#194190",
  },
};
